interface ICheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  disabled?: boolean
}

export const Checkbox = ({
  checked,
  onChange,
  label,
  disabled = false
}: ICheckboxProps) => {
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        disabled={disabled}
        style={{
          width: '16px',
          height: '16px',
          cursor: disabled ? 'not-allowed' : 'pointer'
        }}
      />
      <span style={{ fontSize: '14px', userSelect: 'none' }}>{label}</span>
    </label>
  )
}
